import { Record } from 'immutable';

const AgencyConfigLookupRecord = Record({
  agencyId: null,
});

export class AgencyConfigLookup extends AgencyConfigLookupRecord {
  agencyId: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/config/agency-config-lookup.ts